export default __webpack_public_path__ + "static/media/bg-desktop-light.3508d620.jpg";